import React, { useState, useEffect } from 'react';
import vr from '../../../../../utils/Verifiers';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import './formularioRegistroBloque.css';
import FormulasBloques from './FormulasBloquesEdicion';

const FormularioRegistroBloqueEdicion = (p) => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const formulas = new FormulasBloques();
    const selecciones = p.selecciones;
    const setselecciones = p.setselecciones;

    const [dialog, setdialog] = useState({ show: false });
    const [bloques, setbloques] = useState([]);
    const [flores, setflores] = useState([]);
    const [variedades, setvariedades] = useState([]);
    const [colores, setcolores] = useState([]);

    const getFlores = async () => {
        setbloques(p.flores ?? {});
        setflores(Object.keys(p.flores ?? {}));
        setvariedades([]);
        setcolores([]);
    }

    const changeBloque = (ev) => {
        const { name, value } = ev.target;

        if (name === 'flor') {
            const nuevasVariedades = Object.keys(bloques[value]?.variedades ?? {});
            setvariedades(nuevasVariedades);
            setcolores([]);
            setselecciones(prev => ({ ...prev, flor: value, variedad: '', color: '' }));
            return;
        }

        if (name === 'variedad') {
            const variedadColores = Object.keys(bloques[selecciones.flor]?.variedades?.[value]?.colores ?? {});
            setcolores(variedadColores);
            setselecciones(prev => ({ ...prev, variedad: value, color: '' }));
            return;
        }

        setselecciones(prev => ({ ...prev, color: value }));
    }

    const changeFechas = (ev) => {
        const { name, value } = ev.target;

        setselecciones(prev => {
            let semanainicio = prev.semanainicio;
            let propagacion = prev.propagacion;
            let transplante = prev.transplante;
            let campo = prev.campo;
            let semanaCosecha = prev.semanaCosecha;

            if (name === 'semanainicio') {
                if (!formulas.semanaValida(value)) {
                    return { ...prev, [name]: value };
                }
                semanainicio = value;
                transplante = formulas.sumar_semanas(+semanainicio, propagacion, setdialog);

                if (!transplante) {
                    return { ...prev, [name]: value };
                }
                semanaCosecha = formulas.sumar_semanas(+transplante, campo, setdialog);
                if (!semanaCosecha) {
                    return { ...prev, [name]: value };
                }
            } else if (name === 'propagacion') {
                propagacion = value;
                transplante = formulas.sumar_semanas(+semanainicio, propagacion, setdialog);
                if (!transplante) {
                    return { ...prev, [name]: value };
                }
                semanaCosecha = formulas.sumar_semanas(+transplante, campo, setdialog);
                if (!semanaCosecha) {
                    return { ...prev, [name]: value };
                }
            } else if (name === 'campo') {
                campo = value;
                semanaCosecha = formulas.sumar_semanas(+transplante, campo, setdialog);
                if (!semanaCosecha) {
                    return { ...prev, [name]: value };
                }
            }

            return {
                ...prev,
                [name]: value,
                transplante: transplante,
                semanaCosecha: semanaCosecha,
                campo: campo,
                propagacion: propagacion,
            };
        });
    }

    function changeCalculo(ev) {
        const { name, value } = ev.target;

        setselecciones(prev => {
            let next = { ...prev, [name]: value };

            switch (name) {
                case 'plantas':
                    next = formulas.plantas(next);
                    break;
                case 'por_germinacion':
                    next = formulas.por_germinacion(next);
                    break;
                case 'cavidad':
                    next = formulas.cavidad(next);
                    break;
                case 'densidad':
                    next = formulas.densidad(next);
                    break;
                case 'semillas':
                    next = formulas.semillas(next);
                    break;
                case 'charolas':
                    next = formulas.charolas(next);
                    break;
                case 'reqm2':
                    next = formulas.reqm2(next);
                    break;
                case 'recuperacion':
                    next = formulas.recuperacion(next);
                    break;
                case 'cantidadTallos':
                    next = formulas.cantidadTallos(next);
                    break;
                default:
                    break;
            }
            return next;
        });
    }

    const [gruposInputs, setgruposInputs] = useState([
        {
            name: "Fechas",
            funcion: changeFechas,
            inputs: [
                { name: "semanainicio", tipo: "number", title: 'Sem. siembra', value: 0, editable: true },
                { name: "propagacion", tipo: "number", title: 'Ciclo propagación', value: 0, editable: true },
                { name: "campo", tipo: "number", title: 'Ciclo campo', value: 0, editable: true },
                { name: "transplante", tipo: "number", title: 'Sem. trasplante', value: 0, editable: false },
                { name: "semanaCosecha", tipo: "number", title: 'Semana corte', value: 0, editable: false },
            ]
        },
        {
            name: "Germinado y charolas",
            funcion: changeCalculo,
            inputs: [
                { name: "plantas", tipo: "number", size: 120, title: '# Plantas', value: 0, editable: true },
                { name: "por_germinacion", tipo: "number", size: 120, title: 'Germinación', value: 0, editable: true },
                { name: "semillas", tipo: "number", size: 150, title: 'Semillas necesarias', value: 0, editable: true },
                { name: "cavidad", tipo: "number", size: 130, title: 'Cavidad charola', value: 0, editable: true },
                { name: "charolas", tipo: "number", size: 130, title: 'charolas', value: 0, editable: true },
            ]
        },
        {
            name: "Campo",
            funcion: changeCalculo,
            inputs: [
                { name: "densidad", tipo: "number", size: 120, title: 'Densidad', value: 0, editable: true },
                { name: "reqm2", tipo: "number", size: 130, title: 'Metros nec.', value: 0, editable: true },
                { name: "camas", tipo: "number", size: 100, title: 'Camas', value: 1, editable: true },
                { name: "recuperacion", tipo: "number", size: 130, title: 'Recuperación', value: 0, editable: true },
                { name: "cantidadTallos", tipo: "number", size: 130, title: 'Tallos cosecha', value: 0, editable: true },
            ]
        }
    ]);

    const relaciones = {
        'plantas': { toma: ["por_germinacion"], ajusta: ["semillas"] }
    }

    useEffect(() => {
        getFlores();
    }, [p.flores]);

    return (
        <>
            <div className='col-lg-12 m-0 p-2' style={{ lineHeight: 1.1 }}>
                <div className='row justify-content-center align-items-center w-100 m-0 p-0'>
                    <div className='p-2' style={{ width: "100%", maxWidth: "1100px" }}>
                        <div className='row justify-content-start w-100'>
                            <div className='col-lg-12 text-start h4 fw-300 pb-0 mb-1'>Definición del bloque</div>
                            <div className='grid-inputs col-lg-12 m-0'>
                                <div className='form-group pb-2'>
                                    <label className='text-bold'>Flor</label>
                                    <select className='form-control' name='flor' disabled value={selecciones.fl} >
                                        <option value='' >{selecciones.fl}</option>
                                    </select>
                                </div>

                                <div className='form-group'>
                                    <label className='text-bold'>Variedad</label>
                                    <select className='form-control' name='variedad' disabled value={selecciones.variedad}>
                                        <option value='' >{selecciones.vr}</option>
                                    </select>
                                </div>

                                <div className='form-group'>
                                    <label className='text-bold'>Color</label>
                                    <select className='form-control' disabled name='color' value={selecciones.col}>
                                        <option value='' >{selecciones.col}</option>
                                    </select>
                                </div>
                            </div>

                            {
                                gruposInputs.map((grupo, index) => <React.Fragment key={index + grupo.name}>
                                    <div className='col-lg-12 text-start h4 fw-300 pb-0 mb-1 mt-4 mb-1'>{grupo.name}</div>
                                    <div className='grid-inputs col-lg-12 m-0'>
                                        {grupo.inputs.map((input, indexj) => (
                                            <div key={indexj + input.name} className='form-group'>
                                                <label className='text-bold'>{input.title}</label>
                                                <input type={input.tipo} className='form-control' name={input.name} value={selecciones[input.name]} onChange={grupo.funcion} disabled={!input.editable} />
                                            </div>
                                        ))}
                                    </div>
                                </React.Fragment>)
                            }
                        </div>
                    </div>
                </div>
            </div>

            {loader && ldr}
            <VainillaDialog data={dialog} />
        </>

    )
}

export default FormularioRegistroBloqueEdicion;